import { ComboDataDTO, defaultComboDataDTO } from "./ComboDataDTO";

export interface ComboCostDTO extends ComboDataDTO {
    cost: number | null;
}

export const defaultComboCostDTO:ComboCostDTO = {
    ... defaultComboDataDTO,
    cost: 0,
}